<template>
  <div class="item-soignant" :class="{ invited }">
    <div class="avatar"><img :src="require(`@/assets/images/badges/${user.title}-${user.gender.toLowerCase()}.jpg`)" alt="" title=""/></div>
    <p>{{ user.first_name }} {{ user.last_name }}<br><span>{{ user.title }}<br><em>ajouté {{formatDate(user.signup_date)}}</em></span></p>
    <template v-if="!invited">
      <i class="fas fa-trash-alt" @click="removeFromFamily"></i>
      <div :class="{on: user.can.indexOf('see_autoevaluation') !== -1, rapport: true}">
        <i class="fas fa-check-circle" @click="allowAutoeval"></i>
        <i class="fas fa-times" @click="disallowAutoeval"></i>
      </div>
    </template>
  </div>
</template>

<script>
import { dispatch, mapActions } from 'vuex'
import { formatDate } from '@/functions'
export default {
  props: ['user', 'name', 'active', 'invited'],
  methods: {
    formatDate,
    async removeFromFamily() {
      await this.$store.dispatch('removeFromFamily', { caregiverId: this.user.id })
      this.$store.dispatch('addNotice', { message: `${this.user.first_name} ${this.user.last_name} a été retiré de la liste des soignant de votre enfant`})
    },
    async allowAutoeval() {
      this.$store.dispatch('setAuthorizations', { id: this.user.id, can: 'see_autoevaluation;' })
    },
    async disallowAutoeval() {
      this.$store.dispatch('setAuthorizations', { id: this.user.id })
    }
  }
}
</script>

<style scoped>

.invited {
  opacity: 0.4;
}

.item-soignant {
  background: #f1f1f1;
  padding: 5px 15px;
  margin-bottom: 5px;
  position: relative;
}

.item-soignant .avatar {
  width: 70px;
  display: inline-block;
  margin-right: 15px;
  position: relative;
  top: -10px;
}
.item-soignant .avatar img { margin: 0px;}


.item-soignant p {
  font-size: 21px;
  color: #413492;
  line-height: 21px;
  margin-bottom: 0px;
  margin-top: 0px;
  font-family: 'blogger_sansbold';
  display: inline-block;
  min-width: 200px;
      position: relative;
    top: 15px;
  }
.item-soignant span { font-size: 18px; color: #858585; }
.item-soignant em {  font-size: 14px; color: #858585; font-family: 'blogger_sanslight'; }
.item-soignant .rapport {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 0 20px;
  font-size: 24px;
  display: inline-block;
  margin-right: 25px;
  float: right;
  margin-top: 30px;
}
.item-soignant .rapport .fa-check-circle {
  color: #36bf2e;
  margin-right: 25px;
}

.item-soignant .rapport .fa-times {
  color: #de2128;
}
.item-soignant .fa-trash-alt {
  color: #a6a6a6;
  font-size: 24px;
  cursor: pointer;
  float: right;
  margin-top: 37px;
}
.item-soignant .fa-trash-alt:hover {  color: #de2128;  }
.item-soignant .rapport.on .fa-times {   color: #a6a6a6; cursor: pointer; }
.item-soignant .rapport.on .fa-times:hover {   color: #de2128; }

.item-soignant .rapport:not(.on) .fa-check-circle {   color: #a6a6a6; cursor: pointer; }
.item-soignant .rapport:not(.on) .fa-check-circle:hover {   color: #36bf2e; }
.item-soignant.invited:before {
    content: "en attente de validation";
    display: inline-block;
    position: absolute;
    z-index: 10;
    font-size: 18px;
    color: #fff;
    line-height: 21px;
    margin-bottom: 0px;
    margin-top: 0px;
    font-family: 'blogger_sansbold';
    width: 60%;
    text-align: center;
    top: 50%;
    right: 0;
    margin-top: -20px;
    background: #413492;
    padding: 10px;
}


@media (max-width: 1300px) { .item-soignant p {    min-width: 150px; } }

@media (max-width: 500px) {

  .item-soignant .avatar {display: none;}
  .item-soignant p {min-height: 90px;}
  .item-soignant .rapport .fa-check-circle {  margin-right: 15px; }
  .item-soignant .rapport {    padding: 0 12px; font-size: 20px; }
  .item-soignant .fa-trash-alt { font-size: 15px; }

}


</style>
